import { ChangeDetectionStrategy, Component, computed, OnInit, Signal } from '@angular/core';
import { SHeaderComponent } from '../../shared/s-header/s-header.component';
import { ElementsType } from '../../../state-management/model/enums/state.enums';
import { BaseCardsGalleryComponent } from './base-cards-gallery/base-cards-gallery.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { CBaseComponent } from '../base/c-base.component';
import { CoordinatesSystem, ScreenWidthBreakpoints } from '../../../state-management/model/enums/screen-size.enums';
import { ScreensizeStateService } from '../../../state-management/services/screensize-state.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-c-cards-gallery',
    imports: [
        CommonModule,
        SHeaderComponent,
        BaseCardsGalleryComponent,
        MatGridListModule
    ],
    templateUrl: './c-cards-gallery.component.html',
    styleUrl: './c-cards-gallery.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CCardsGalleryComponent extends CBaseComponent implements OnInit {
  public isSmallScreen$: Signal<boolean> = this.screensizeState.isScreenSizes(CoordinatesSystem.ScreenWidth, [ScreenWidthBreakpoints.XSmall, ScreenWidthBreakpoints.Small]);

  public gridconfig$ = computed(() => {
    let length = this.groupElementSignals['base-card']().length;
    if (length === 0) return { cols: 1, gutterSize: '1rem' };
    if (length === 1) return { cols: 1, gutterSize: '1rem' };
    if (length === 2) return { cols: 2, gutterSize: '1rem' };
    if (length === 4) return { cols: 2, gutterSize: '1rem' }; 

    return {
      cols: this.isSmallScreen$() ? 2 : 3,
      gutterSize: this.isSmallScreen$() ? '1rem' : '2rem'
    };
  });

  constructor(private screensizeState: ScreensizeStateService ) { 
    super();
  }

  override ngOnInit() {
    this.singleLabels = [ElementsType.ComponentHeader];
    this.groupLabels = [ElementsType.BaseCard];
    super.ngOnInit();
  }
}